import {
  SWITCH_LANGUAGE,
  TOGGLE_COLLAPSED_NAV,
  WINDOW_WIDTH,
  LOAD_DATA,
} from "../../constants/ActionTypes";
import {
  LAYOUT_TYPE,
  LAYOUT_TYPE_FULL,
  NAV_STYLE,
  THEME_COLOR_SELECTION,
  THEME_COLOR_SELECTION_PRESET,
  THEME_TYPE,
  THEME_TYPE_SEMI_DARK,
  NAV_STYLE_MINI_SIDEBAR
} from "../../constants/ThemeSetting";

const languageArray = [
  {
    id: 1,
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "us",
  },
  {
    id: 2,
    languageId: "maltese",
    locale: "mt",
    name: "Maltese",
    icon: "mt",
  },
];
var localLanguageId =
  typeof localStorage.getItem("X-LANG") === "undefined" ||
  localStorage.getItem("X-LANG") === null
    ? 1
    : localStorage.getItem("X-LANG");
var selectedLanguage = languageArray.filter((item) => {
  return (
    item.id ===
    (localLanguageId === "undefined" ? 1 : parseInt(localLanguageId))
  );
});
const initialSettings = {
  navCollapsed: true,
  navStyle: NAV_STYLE_MINI_SIDEBAR,
  layoutType: LAYOUT_TYPE_FULL,
  themeType: THEME_TYPE_SEMI_DARK,
  colorSelection: THEME_COLOR_SELECTION_PRESET,
  pathname: "",
  width: window.innerWidth,
  isDirectionRTL: false,
  loadData: false,
  /*locale: {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us'
  }*/
  locale: selectedLanguage[0],
};

const settings = (state = initialSettings, action) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE":
      return {
        ...state,
        pathname: action.payload.location.pathname,
        navCollapsed: false,
      };
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.navCollapsed,
      };
    case WINDOW_WIDTH:
      return {
        ...state,
        width: action.width,
      };
    case THEME_TYPE:
      return {
        ...state,
        themeType: action.themeType,
      };
    case THEME_COLOR_SELECTION:
      return {
        ...state,
        colorSelection: action.colorSelection,
      };

    case NAV_STYLE:
      return {
        ...state,
        navStyle: action.navStyle,
      };
    case LAYOUT_TYPE:
      return {
        ...state,
        layoutType: action.layoutType,
      };

    case SWITCH_LANGUAGE:
      localStorage.setItem("X-LANG", action.payload.languageId);
      return {
        ...state,
        locale: action.payload,
      };
    case LOAD_DATA:
      return {
        ...state,
        loadData: action.payload,
      };
    default:
      return state;
  }
};

export default settings;
